import React, { Component } from 'react';
import $ from "jquery";

let dotSize = 20;   //触感点的直径

class AutoWriteLetter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            points: [],
            style: {},
            drawNum: 0,
        };
    }

    componentDidMount() {
        const that = this;
        const { item } = this.props;
        const { points } = this.state;
        const $id = $('div[id*="wrap_letter"]');
        if (item.actionType === "LETTER_REPLAY_FEEDBACK") {
            $('#countdoenTimeout').remove();
        } else {
            that.setState({
                style: {
                    "position": "absolute",
                    "top": $id.css("top"),
                    "left": $id.css("left"),
                    "width": "100%",
                    "height": "100%",
                }
            }, () => {
                if (item && item.detail && item.detail.linepoints && item.detail.linepoints.length) {
                    // that.drawLine();
                    const linepoints = item.detail.linepoints;
                    for (let i = 0; i < linepoints.length; i++) {
                        let newPoints = points;
                        newPoints.push({ "x": linepoints[i].x, "y": linepoints[i].y });

                        if (i < linepoints.length - 1) {
                            setTimeout(() => {
                                that.setState({
                                    points: newPoints,
                                });
                            }, 10);
                        }
                    }

                    let curCount = $('.autoWriteLetter').length;
                    if (window.dotDatas && window.dotDatas[curCount] && window.dotDatas[curCount].length > linepoints.length) {
                        setTimeout(() => {
                            that.setState({
                                points: []
                            })
                        }, 350);
                    }
                }
            })
        }
    }

    drawLine() {
        const that = this;
        const { item } = this.props;
        const { drawNum, startX, startY } = this.state;
        if (item && item.detail && item.detail.linepoints) {
            const c = document.getElementById('circleCanvas');
            const ctx = c.getContext("2d");
            const linepoints = item.detail.linepoints;

            if (drawNum < linepoints.length - 1) {
                setTimeout(() => {
                    that.setState({
                        drawNum: drawNum + 1,
                        startX: linepoints[drawNum].x,
                        startY: linepoints[drawNum].y,
                    }, () => {
                        if (drawNum > 0) {
                            ctx.beginPath();
                            ctx.moveTo(startX * 690, startY * 518);//起始位置
                            ctx.lineTo(linepoints[drawNum].x * 690, linepoints[drawNum].y * 518);//停止位置
                            ctx.lineWidth = dotSize;
                            ctx.strokeStyle = "#ffe85f";
                            ctx.stroke();
                        }
                    });
                }, 10);
            }

        }
    }

    render() {
        const { item } = this.props;
        const { points, style } = this.state;
        return (
            // <canvas className="autoWriteLetter" id="circleCanvas" width="690" height="518" style={style} />
            <div>
                {
                    item && item.actionType === "LETTER_REPLAY_DRAWLINE" ?
                        <div className="autoWriteLetter" style={style}>
                            {
                                points && points.length ?
                                    points.map((linepoint, index) => {
                                        return (
                                            <div key={index} style={{
                                                "width": dotSize + 'px',
                                                "height": dotSize + 'px',
                                                "borderRadius": dotSize + 'px',
                                                "marginTop": -dotSize / 2 + 'px',
                                                "marginLeft": -dotSize / 2 + 'px',
                                                "position": "absolute",
                                                "top": linepoint.y * 100 + "%",
                                                "left": linepoint.x * 100 + "%",
                                                "backgroundColor": "#ffe85f"
                                            }} />
                                        )
                                    })
                                    : null
                            }
                        </div>
                        : null
                }
            </div>
        );
    }
}

export default AutoWriteLetter;



// WEBPACK FOOTER //
// ./src/components/review/AutoWriteLetter.js